import { render } from "./ProducerQuote.vue?vue&type=template&id=1590d96c"
import script from "./ProducerQuote.vue?vue&type=script&lang=js"
export * from "./ProducerQuote.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__